import { render, staticRenderFns } from "./NotificationDeletionModal.vue?vue&type=template&id=6941f869&scoped=true&"
import script from "./NotificationDeletionModal.vue?vue&type=script&lang=js&"
export * from "./NotificationDeletionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6941f869",
  null
  
)

export default component.exports